import { render, staticRenderFns } from "./trendChart.vue?vue&type=template&id=a4616b0e&scoped=true&"
import script from "./trendChart.vue?vue&type=script&lang=js&"
export * from "./trendChart.vue?vue&type=script&lang=js&"
import style0 from "./trendChart.vue?vue&type=style&index=0&id=a4616b0e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4616b0e",
  null
  
)

export default component.exports